import creditTypes from "./credit.types";

const INITIAL_STATE = {
  accountDetail: undefined,
  accountDetail_isLoading: false,

  activeTab: 0,
};

const creditReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //
    case creditTypes.SET_CREDIT_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    //
    case creditTypes.FETCH_ACCOUNTDEATAIL_START:
      return {
        ...state,
        accountDetail_isLoading: true,
      };
    case creditTypes.FETCH_ACCOUNTDEATAIL_SUCCESS:
      return {
        ...state,
        accountDetail_isLoading: false,
        accountDetail: action.payload,
      };

    //
    default:
      return state;
  }
};

export default creditReducer;
